import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import * as types from "./types";
import * as actions from "./action";
import * as actionTypes from "./actionTypes";
import * as services from "./service";
import * as alert from "../../alert/actions";

/*
  Worker Saga: Fired on FETCH_MetaDataExtractor_REQUEST action
*/
function* postMetaDatExtractorSaga(action: types.PostMetaDataExtractorRequest) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<any | types.IMetaDataExtractorFailure> = yield call(services.postMetaDataExtractor, action.payload);
    if (response.status === 201) {
      yield put(
        actions.postMetaDataExtractorSuccess({
          extMetaDataStatus: { metadata: action.payload!, success: true }
        })
      );
      yield put(
        alert.enqueueSnackbar({
          message: `Table metadata for ${action.payload.businessMetadata.tableName} submitted successfully, Timestamp: ${timestamp}`,
          options: { variant: "success" },
        })
      );
    }

    //Show IApiError
    if (response.status !== 201) {
      let apiError = response.data as types.IMetaDataExtractorFailure;
      let errmsg = `Error in table ${action.payload.businessMetadata.tableName} Status Code: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
      yield put(
        alert.enqueueSnackbar({
          message: errmsg,
          options: { variant: "error" },
        })
      );
      yield put(
        actions.postMetaDataExtractorFailure({
          extMetaDataStatus: { metadata: action.payload, success: false },
          error: apiError,
        })
      );
    }
  } catch (e: any) {
    yield put(
      actions.postMetaDataExtractorFailure({
        extMetaDataStatus: { metadata: action.payload, success: false },
        error: e.message,
      })
    );
  }
}

//put Metadata Extractor
function* putMetadataExtractorSaga({ tableId, payload }: types.PutExtractorMetadataRequest) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<types.IPutExtractorMetadataSuccess | types.IApiError> = yield call(services.putExtractorMetadata, tableId, payload);

    if (response.status === 204) {
      let dataPayload = response.data as types.IPutExtractorMetadataSuccess;
      yield put(
        actions.putExtractorMetadataSuccess({
          extMetaDataStatus: dataPayload,
        })
      );
      let successMsg = `The extractor metadata was successfully edited.ID: ${tableId}, Timestamp: ${timestamp}`;
      yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
    }

    if (response.status !== 204) {
      let apiError = response.data as types.IApiError;
      let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}.Details: ${apiError.detail}, Timestamp: ${timestamp}`;
      yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));

    }
  } catch (e: any) {
    yield put(
      actions.putExtractorMetadataFailure({
        error: e,
      })
    );
  }
}

//Get Extractor Table MetaData
function* getExtTableMetaDataSaga(action: types.FetchEXTTableMetaDataRequest) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<any | types.IMetaDataExtractorFailure> = yield call(services.getExtTableMetaData, action.params);
    if (response.status === 200) {
      yield put(
        actions.fetchExtTableMetaDataSuccess({
          table_name: action.params.table_name,
          tableMetadata: response.data as types.IGetEXTTableMetaData[],
        })
      );
    }

    //Show IApiError
    if (response.status !== 200) {
      let apiError = response.data as types.IMetaDataExtractorFailure;
      let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}.Details: ${apiError.detail}, Timestamp: ${timestamp} `;
      yield put(
        alert.enqueueSnackbar({
          message: errmsg,
          options: { variant: "error" },
        })
      );
    }
  } catch (e: any) {
    yield put(
      actions.fetchExtTableMetaDataFailure({
        error: e.message,
      })
    );
  }
}

//Get Foundry Metadata
function* getFoundryMetaDataSaga(action: types.FetchFoundryTableMetaDataRequest) {
  const timestamp = new Date().toLocaleString();
  try {
    const response: AxiosResponse<any | types.IMetaDataExtractorFailure> = yield call(services.getFoundryMetaData, action.params);
    if (response.status === 200) {
      yield put(
        actions.fetchFoundryTableMetaDataSuccess({
          foundryMetadata: response.data as types.IGETFoundryMetaData[],
        })
      );
    }

    //Show IApiError
    if (response.status !== 200) {
      let apiError = response.data as types.IMetaDataExtractorFailure;
      let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}.Details: ${apiError.detail}, Timestamp: ${timestamp} `;
      yield put(
        alert.enqueueSnackbar({
          message: errmsg,
          options: { variant: "error" },
        })
      );
    }
  } catch (e: any) {
    yield put(
      actions.fetchFoundryTableMetaDataFailure({
        error: e.message,
      })
    );
  }
}

/*
    Watcher saga - intercept the action fired from view
    Starts worker saga on latest dispatched `FETCH_SchemaSelection_REQUEST` action.
    Allows concurrent increments.
  */

function* metaDataPostExtractorSaga() {
  yield takeEvery(
    actionTypes.POST_METADATAEXTRACTOR_REQUEST,
    postMetaDatExtractorSaga
  );
}

function* metaDataPutExtractorSaga() {
  yield takeEvery(
    actionTypes.PUT_METADATAEXTRACTOR_REQUEST,
    putMetadataExtractorSaga
  );
}

function* extTableMetaDataSaga() {
  yield takeEvery(
    actionTypes.FETCH_EXTTABLEMETADATA_REQUEST,
    getExtTableMetaDataSaga
  );
}

//Foundry
function* foundryMetaDataDataSaga() {
  yield takeEvery(
    actionTypes.FETCH_FOUNDRYTABLEMETADATA_REQUEST,
    getFoundryMetaDataSaga
  );
}

function* metaDataExtractorSaga() {
  yield all([metaDataPostExtractorSaga(), metaDataPutExtractorSaga(), extTableMetaDataSaga(), foundryMetaDataDataSaga()]);
}

export default metaDataExtractorSaga;
